<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">模板页</div>
    <div class="third-title"><span>模板页样式</span></div>
    <div class="order-detail-basic">
      <el-form :model="templateMsg" label-width="100px" ref="formRef">
        <el-form-item label="模板页缩略图">
          <div style="height: 150px;width:170px;">
            <templateThumbnail :templateGroup="templateMsg"></templateThumbnail>
          </div>
        </el-form-item>
        <el-form-item label="已关联版式">
          <div class="single_layout" v-for="(item, index) in templateMsg.layouts" :key="item.id">
            <el-image :src="item.layoutThumbnail" style="height:100px" fit="cover" :preview-src-list="getImgList(index)">
            </el-image>
            <p class="color-blue" @click="cancelRelate(item.xrefId)">解除</p>
          </div>
        </el-form-item>
      </el-form>
      <div style="float:right;margin:0 200px 200px 0">
        <el-button v-if="$route.query.type === 'check'" type="primary" @click="$router.go(-1)" round>返回</el-button>
        <el-button v-if="$route.query.type === 'audit'" @click="audit('REJECTED')" round>审核拒绝</el-button>
        <el-button v-if="$route.query.type === 'audit'" @click="audit('AUDITED')" type="primary" round>审核通过</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import templateThumbnail from '@/components/templateThumbnail.vue'

import { templateGroupQueryTemplateGroupById, templateGroupAuditTemplateGroup, templateGroupCancelRelateLayout } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  components: {
    templateThumbnail
  },
  data () {
    return {
      templateMsg: {}
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getTemplateMsg()
  },
  methods: {
    cancelRelate (id) {
      templateGroupCancelRelateLayout([id])
        .then(res => {
          if (res.data.success) {
            this.$message.success('解除成功')
            this.getTemplateMsg()
          }
        })
    },
    getImgList (index) {
      let list = this.templateMsg.layouts.map(item => {
        return item.layoutThumbnail
      })
      return list
    },
    audit (auditStatus) {
      templateGroupAuditTemplateGroup({ auditStatus, idList: [this.$route.query.id] }).then(res => {
        if (res.data.success) {
          this.$message.success('已审核')
          this.$router.go(-1)
        }
      })
    },
    getTemplateMsg () {
      templateGroupQueryTemplateGroupById(this.$route.query.id).then(res => {
        if (res.data.success) {
          let obj = res.data.data

          this.templateMsg = obj
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.imgBox {
  border: 1px solid #000;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
}

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}

.singleImg {
  flex: 1;
}

.single_layout {
  border: 1px solid #000;
  margin-right: 10px;
  float: left;
  display: felx;
  flex-flow: column;
  justify-content: space-between;
  border-radius: 5px;
  overflow: hidden;

  p {
    flex: 1;
    text-align: center;
    border-top: 1px solid #000;
  }
}
</style>
